import { Simulation, simulationVide, ShareCode } from '../types/main';

export const addInArray = <T>(array: T[], value: T): void => {
  if (array.indexOf(value) === -1) {
    array.push(value);
  }
}

export const removeFromArray = <T>(array: T[], value: T): void => {
  var index = array.indexOf(value);
  if (index !== -1) {
    array.splice(index, 1);
  }
}

// sera une fonction qui ira chercher le message d'erreur dans un fichier JSON
export const IGMessage = (label: string): string => {
  return label;
}

// sera une fonction qui ira chercher le label d'erreur dans un fichier JSON
// exemple : intitulé de bouton...
export const IGLabel = (label: string): string => {
  return label;
}

export const formatServerMessage = (message: string): string => {
  let returnedMessage = '';

  const splittedMessage = message.split('_$$_');

  for (let i = 0; i < splittedMessage.length; i += 1) {
    returnedMessage += i % 2 === 0 ? IGMessage(splittedMessage[i]) : splittedMessage[i];
  }

  return returnedMessage;
};

export const copyAndRemove = (array: string[], value: string): string[] => {
  const _array = [...array];
  removeFromArray(_array, value);
  return _array;
}
export const copyAndPush = (array: string[], value: string): string[] => {
  const _array = [...array];
  _array.push(value);
  return _array;
}

export const isEqual = (ben1: any, ben2: any): boolean => {
  // const attr = [
  //   'beneficiaire',
  //   'coordonnees',
  //   'situation_famille',
  //   'revenus_fiscalite',
  //   'investissement',
  //   'hypotheses_revalorisation',
  //   'caracteristiques_investissement',
  //   'financement_investissement',
  //   'ventilation_fiscale',
  // ] as (keyof Simulation)[];
  const attrArray = [] as (keyof Simulation)[];
  const attr = Object.keys(simulationVide);
  for (let i = 0 ; i < attr.length; i += 1) {
    for (const key of Object.keys(ben1[attr[i]])) {
      if (attrArray.includes(attr[i] as keyof Simulation)) {
        for (let j = 0; j < ben1[attr[i]][key].length; j += 1){
          if (ben1[attr[i]][key][j] != ben2[attr[i]][key][j]) return false;
        }
      } else {
        if (ben1[attr[i]][key] != ben2[attr[i]][key]) {
          return false;
        }
      }
    }
  }
  return true;
}

export const formatteValeur = (
  format: string,
  periode: string,
  valeur: number,
  afficheNegatif?: boolean,
): number | string => {
  const afficheNegatifString = afficheNegatif ? '- ' : '';
  const stringPeriode = periode === '' ? '' : ' / ' + periode;
  let _value;
  switch (format) {
    case 'euros':
      _value = new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
      }).format(valeur);
      break;
    case 'pourcents':
      _value = valeur + ' %';
      break;
    case 'sur20':
      _value = valeur + 'note / 20';
      break;
    case 'surfacem2':
      _value = valeur + ' m²';
      break;
    case 'annees':
      _value = valeur >= 2 ? valeur + ' ans' : valeur + ' an';
      break;
    default:
      _value = valeur;
      break;
  }
  return afficheNegatifString + _value + stringPeriode;
}

export const formatLabel = (format: string, periode: string): string => {
  const stringPeriode = periode === '' ? '' : ' par ' + periode;
  let stringUnite = '';
  switch (format) {
    case 'euros':
      stringUnite = 'en €';
      break;
    case 'pourcents':
      stringUnite = 'en %';
      break;
    case 'sur20':
      stringUnite = 'note / 20';
      break;
    case 'surfacem2':
      stringUnite = 'en m²';
      break;
    case 'annees':
      stringUnite = 'en années';
      break;
    default:
      break;
  }
  return format || periode ? ` (${stringUnite}${stringPeriode})` : '';
}

export const creeClassNamesZoneSaisie = (largeurEcran: number, nombreColonnes: number): string[] => {
  const ret = ['zone-saisie'];
  // if (largeurEcran > 1600) {
  if (largeurEcran > 1600 && nombreColonnes >= 4) {
    ret.push('large4');
  } else if (largeurEcran > 1200 && nombreColonnes >= 3) {
    ret.push('large3');
  } else if (largeurEcran > 800) {
    ret.push('large2');
  } else {
    ret.push('large1');
  }
  return ret;
}

export const scrollToRef = (ref: any): void => {
  console.log('scrollToRef, ref=', ref);
  ref.current.scrollIntoView({ behavior: 'smooth' });
  // window.scrollTo(0, ref.current.offsetTop);
}
export const decodeShareCode = (code: string): ShareCode | null => {
  let pCode;
  let nCode;
  let fCode;
  const codePremiereLettre = correspondanceInv(code[0]);
  switch (codePremiereLettre) {
    case '0':
      pCode = code.substring(1, 11);
      nCode = code.substring(11, 21);
      fCode = code.substring(21, 22);
      break;
    case '1':
      pCode = code.substring(1, 11);
      nCode = code.substring(12, 22);
      fCode = code.substring(11, 12);
      break;
    case '2':
      pCode = code.substring(11, 21);
      nCode = code.substring(1, 11);
      fCode = code.substring(21, 22);
      break;
    case '3':
      pCode = code.substring(12, 22);
      nCode = code.substring(1, 11);
      fCode = code.substring(11, 12);
      break;
    case '4':
      pCode = code.substring(2, 12);
      nCode = code.substring(12, 22);
      fCode = code.substring(1, 2);
      break;
    case '5':
      pCode = code.substring(12, 22);
      nCode = code.substring(2, 12);
      fCode = code.substring(1, 2);
      break;
    default:
      pCode = '';
      nCode = '';
      fCode = '';
      break;
  }
  const p = decodeNumber(pCode);
  const n = decodeNumber(nCode);
  const f = decodeFiliere(fCode);

  // console.log('decode', code, codePremiereLettre, pCode, nCode, fCode, p, n, f);
  
  let ret2 = { p, n, f };
  return p === 0 || n === 0 || f === '' ? null : ret2;
}
export const codeShareCode = (points: number, nbTotalPoints: number, filiere: typeof simulationVide.filiere): string => {
  const codePoints = codeNumber(points);
  const codeNbTotalPoints = codeNumber(nbTotalPoints);
  const codeF = codeFiliere(filiere);
  const a =  getRandomInt(6);
  const premiereLettre = correspondance(a.toString());
  let ret;
  switch (a) {
    case 0:
      ret = `${premiereLettre}${codePoints}${codeNbTotalPoints}${codeF}`;
      break;
    case 1:
      ret = `${premiereLettre}${codePoints}${codeF}${codeNbTotalPoints}`;
      break;
    case 2:
      ret = `${premiereLettre}${codeNbTotalPoints}${codePoints}${codeF}`;
      break;
    case 3:
      ret = `${premiereLettre}${codeNbTotalPoints}${codeF}${codePoints}`;
      break;
    case 4:
      ret = `${premiereLettre}${codeF}${codePoints}${codeNbTotalPoints}`;
      break;
    case 5:
      ret = `${premiereLettre}${codeF}${codeNbTotalPoints}${codePoints}`;
      break;
    default:
      ret = ``;
      break;
  }
  return ret;
}


export const codeFiliere = (filiere: typeof simulationVide.filiere): string => {
  switch (filiere) {
    case 'ES':
      return 'j';
    case 'S':
      return 'f';
    case 'L':
      return 'y';
    case 'STMG':
      return 'l';
    default:
      return 'm';
  }
}
const decodeFiliere = (code: string): typeof simulationVide.filiere => {
  switch (code) {
    case 'j':
      return 'ES';
    case 'f':
      return 'S';
    case 'y':
      return 'L';
    case 'l':
      return 'STMG';
    default:
      return '';
  }
}

const correspondance = (lettre: string): string => {
  switch (lettre) {
    case '0':
      return 'g';
    case '1':
      return 'u';
    case '2':
      return 'e';
    case '3':
      return 'r';
    case '4':
      return 's';
    case '5':
      return 'o';
    case '6':
      return 'x';
    case '7':
      return 'n';
    case '8':
      return 'q';
    case '9':
      return 'z';
    case '.':
      return 'i';
    default:
      return 'm';
  }
}

const correspondanceInv = (lettre: string): string => {
  switch (lettre) {
    case 'g':
      return '0';
    case 'u':
      return '1';
    case 'e':
      return '2';
    case 'r':
      return '3';
    case 's':
      return '4';
    case 'o':
      return '5';
    case 'x':
      return '6';
    case 'n':
      return '7';
    case 'q':
      return '8';
    case 'z':
      return '9';
    case 'i':
      return '.';
    default:
      return '';
  }
}

// renvoie alea entre 0 et max - 1
const getRandomInt = (max: number): number => {
  return Math.floor(Math.random() * Math.floor(max));
}
const randomLettreInvalide = (max: number): string => {
  const a = getRandomInt(max);
  switch (a) {
    case 0:
      return 'd';
    case 1:
      return 'k';
    case 2:
      return 'p';
    case 3:
      return 't';
    case 4:
      return 'v';
    case 5:
      return 'b';
    case 6:
      return 'c';
    case 7:
      return 'h';
    default:
      return 'm';
  }
}

export const codeNumber = (nombre: number): string => {
  const chaine = nombre.toString();
  const tab = Array(10).fill('a');
  for (let i = 0; i < chaine.length; i += 1) {
    tab[(7 * i) % 10] = correspondance(chaine[i]);
  }
  for (let i = chaine.length; i < 10; i += 1) {
    tab[(7 * i) % 10] = randomLettreInvalide(8);
  }
  return tab.join('');
}

export const decodeNumber = (c: string): number => {
  if (c.length < 10) return 0;
  const nombreString = 
    correspondanceInv(c[0])
    + correspondanceInv(c[7])
    + correspondanceInv(c[4])
    + correspondanceInv(c[1])
    + correspondanceInv(c[8])
    + correspondanceInv(c[5])
    + correspondanceInv(c[2])
    + correspondanceInv(c[9]);
  return parseFloat(nombreString);
}
